// Local media — bundled automatically by the build tool (Vite/CRA both
// support this). Drop the /assets/gallery folder into src/ exactly as is.
import gallery01 from "./assets/gallery/gallery-01.jpg";
import gallery02 from "./assets/gallery/gallery-02.jpg";
import gallery03 from "./assets/gallery/gallery-03.jpg";
import gallery04 from "./assets/gallery/gallery-04.jpg";
import gallery05 from "./assets/gallery/gallery-05.jpg";
import gallery06 from "./assets/gallery/gallery-06.jpg";
import gallery07 from "./assets/gallery/gallery-07.jpg";
import gallery08 from "./assets/gallery/gallery-08.jpg";
import galleryVideo from "./assets/gallery/video.mp4";
import videoPoster from "./assets/gallery/video-poster.jpg";

export const LOGO =
  "/images/logo.png";

export const INSTAGRAM = "https://instagram.com/aaheekathebarber";
export const INSTAGRAM_HANDLE = "@aaheekathebarber";

const SQ_BASE =
  "https://book.squareup.com/appointments/7tvexfgd9bq6u5/location/L2M10CNGXY1PM/services";

export const BOOK_ALL = SQ_BASE;

export const SERVICES = [
  { id: "fade-beard", name: "Fade & Beard", desc: "Fade + full beard service", price: "A$55.00", duration: "1 hr", link: `${SQ_BASE}/BLW7R6WGAEIRKIXSAKPXM5ME` },
  { id: "fade", name: "Fade", desc: "Skin, mid, or low fade", price: "Price varies", duration: "1 hr", link: `${SQ_BASE}/SFIQNOWCXLPAQC67AZKC5HFI` },
  { id: "student", name: "Highschool Student's Cut", desc: "Student pricing", price: "Price varies", duration: "1 hr", link: `${SQ_BASE}/UC3BXFCPYUVXOGS7TDSCC2IR` },
  { id: "standard", name: "Standard Cut", desc: "Standard haircut and trim", price: "A$40.00", duration: "1 hr", link: `${SQ_BASE}/GOUQRNIHUWX5CXOFDFOXYLQO` },
  { id: "beard", name: "Beard Only", desc: "Beard line-up and trim, no haircut", price: "A$30.00", duration: "25 min", link: `${SQ_BASE}/6ILBUC6VZOKOOIRDQHMBMR2M` },
];

// Real client photos — replaces the old Unsplash/Pexels placeholders
export const GALLERY = [
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
];

// Featured gallery video — replaces the old static FEATURED_IMG banner.
// 9:16 vertical, ~18s, muted-autoplay with tap-to-unmute in Gallery.jsx.
export const GALLERY_VIDEO = galleryVideo;
export const VIDEO_POSTER = videoPoster;

export const HOURS = [
  { day: "Wednesday", time: "10:00 AM – 6:00 PM" },
  { day: "Thursday", time: "10:00 AM – 6:00 PM" },
  { day: "Friday", time: "10:00 AM – 6:00 PM" },
  { day: "Saturday", time: "9:00 AM – 5:00 PM" },
  { day: "Sun – Tue", time: "Closed", closed: true },
];
